module.exports = __webpack_public_path__ + "static/img/deloitte.7359da5d.png";